import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../common/forms/custom.validators';
import { Injectable } from '@angular/core';
import { ContractorAppEntityContractorWrite } from '../../../../../../openapi';

@Injectable()
export class ContractorItemForm extends AppForm {
  constructor() {
    super({
      applicantType: new FormControl('', {
        validators: [Validators.required],
        nonNullable: true
      }),
      name: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      nip: new FormControl('', { nonNullable: true, validators: [Validators.required, CustomValidator.nip()] }),
      firstName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      lastName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      phone: new FormControl('', {
        validators: [Validators.required, CustomValidator.phone(), Validators.maxLength(255)],
        nonNullable: true
      }),
      phone2: new FormControl('', {
        validators: [CustomValidator.phone(), Validators.maxLength(255)],
        nonNullable: true
      }),
      email: new FormControl('', {
        validators: [
          Validators.required,
          CustomValidator.email(),
          Validators.maxLength(255)
        ],
        nonNullable: true
      }),
      zipCode: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postOffice: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      city: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      street: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      buildingNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      apartmentNumber: new FormControl('', Validators.maxLength(255))
    });
  }

  public get name(): FormControl {
    return this.get('name') as FormControl;
  }

  public get nip(): FormControl {
    return this.get('nip') as FormControl;
  }

  public get lastName(): FormControl {
    return this.get('lastName') as FormControl;
  }

  public get firstName(): FormControl {
    return this.get('firstName') as FormControl;
  }

  public get applicantType(): FormControl {
    return this.get('applicantType') as FormControl;
  }

  public toWriteModel(): ContractorAppEntityContractorWrite {
    return {
      entityType: this.value.applicantType,
      name: this.value?.name || null,
      firstName: this.value?.firstName || null,
      lastName: this.value?.lastName || null,
      nip: this.value?.nip || null,
      phoneNumber: this.value.phone,
      email: this.value.email,
      city: this.value.city,
      houseNumber: this.value.buildingNumber,
      postalCode: this.value.zipCode,
      postOffice: this.value.postOffice,
      apartmentNumber: this.value.apartmentNumber,
      phoneNumber2: this.value.phone2,
      street: this.value.street
    };
  }
}
